import React from 'react';
import {
  Paper,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import {
  BusinessCenter as ClaimIcon,
  Report as ReportIcon,
  Share as ShareIcon
} from '@mui/icons-material';

const BusinessActions = ({ 
  onClaimBusiness,
  onReportBusiness, 
  onShareBusiness,
  businessId,
  businessName
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2, border: 'none' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Business Actions</Typography>
      
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-around',
        mb: 1
      }}>
        {/* Claim Business Button */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <IconButton 
            color="warning"
            onClick={onClaimBusiness}
            aria-label={`Claim ${businessName}`}
          >
            <ClaimIcon />
          </IconButton>
          <Typography variant="caption" align="center">
            Claim
          </Typography>
        </Box>
        
        {/* Report Button */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <IconButton 
            color="error"
            onClick={onReportBusiness}
            aria-label={`Report ${businessName}`}
          >
            <ReportIcon />
          </IconButton>
          <Typography variant="caption" align="center">
            Report
          </Typography>
        </Box>
        
        {/* Share Button */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <IconButton 
            color="success"
            onClick={onShareBusiness}
            aria-label={`Share ${businessName}`}
          >
            <ShareIcon />
          </IconButton>
          <Typography variant="caption" align="center">
            Share
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default BusinessActions;